document.addEventListener('DOMContentLoaded', function () {
    let navItems = document.querySelectorAll('.blog-nav-item');

    if (navItems !== null) {
        let navItemsContent = document.querySelector('.blog-nav-content');

        for (const navItem of navItems) {
            let id = (navItem.id.length) - 5;
            let navItemId = navItem.id.slice(0, id);
            let navItemContent = document.getElementById(navItemId);

            navItem.addEventListener('mouseover', () => {
                navItemContent.classList.remove('d-none');
                navItem.classList.add('bg-gray');
            });
            navItem.addEventListener('mouseout', () => {
                navItemContent.classList.add('d-none');
                navItem.classList.remove('bg-gray');
            });

            navItemContent.addEventListener('mouseover', () => {
                navItemContent.classList.remove('d-none');
                navItem.classList.add('bg-gray');

                let contentItems = navItemContent.querySelectorAll('li');

                for (const contentItem of contentItems) {
                    contentItem.addEventListener('mouseover', () => {
                        contentItem.classList.add('bg-gray');
                    });
                    contentItem.addEventListener('mouseout', () => {
                        contentItem.classList.remove('bg-gray');
                    });
                }
            });
            navItemContent.addEventListener('mouseout', () => {
                navItemContent.classList.add('d-none');
            });
        }
    }
});



